import React, { useEffect, useState } from 'react';
import ms from 'milsymbol';

import styles from 'src/app/components/BarComponent/Bar.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { faaliyetData, storageHelper } from 'src/app/helpers';
import { EEngamentRule, EIkmalBirim, ESubFaaliyet, EWeightUnit } from 'src/enums/mixed.enum';
import { contentActions, unitsActions } from 'src/app/redux/actions';
import { getEnumKeyByValue2 } from 'src/app/helpers/enum.helper';
import { algiBinary } from 'src/app/helpers/binaries';
import {
  getAgentName,
  getAnyField,
  isAirMissileIcon,
  prototypeIsNaval,
  senseUpdateRestrictions,
  unitSymbolGenerator,
} from 'src/app/helpers/units.helper';
import { isDefined } from 'class-validator';
import { activityContents, PropsType, tableContents, TasimaTipi } from './sitrep-bar.config';
import { MapUnit, HlaMapUnit, SystemStatus, UnitType } from 'src/types/unit.type';
import {
  convertMeasurement,
  getProperWeightText,
  latLongToDmsConverter,
  remainingTimeCalculator,
} from 'src/app/utils/mapUtil';
import { TmkKalemiOzellikleriResultType } from 'src/types/services/hymotsc/tmk-kalemi-ozellikleri.type';
import { tmkAlgiYapabilirMi, tmkIsSensor, tmkIsWeapon } from 'src/app/helpers/binaries/preset-queries.binary';
import { HLAEchelonEnum, HLAForceIdentifierEnum } from '../../LRC/lrc.config';
import { useTranslation } from 'react-i18next';
import Checkbox from 'antd/es/checkbox/Checkbox';
import Collapse from 'antd/es/collapse/Collapse';
import List from 'antd/es/list';
import Tooltip from 'antd/es/tooltip';
import { get } from 'lodash';
import Select from 'antd/es/select';
import { preloadMilsymbol } from 'src/app/helpers/milSymbol.helper';

const tooltipZIndex = 12000;

const SitrepBar: React.FC<PropsType> = ({ selectedUnitData }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { supplies, systems, aircrafts, navalcrafts, obstacles, commdevices, commands, filteredSystems } = useSelector(
    (state: reduxRootTypes.RootStateType) => state.contentState,
  );
  const { mapViewState, mapVisualSettings } = useSelector((state: reduxRootTypes.RootStateType) => state.mapState);

  const { units, hlaMapUnits, weightUnit } = useSelector((state: reduxRootTypes.RootStateType) => state.unitsState);

  // const { kontrolEtmenler } = useSelector((state: reduxRootTypes.RootStateType) => state.userState);

  // const { gameId } = useSelector((state: reduxRootTypes.RootStateType) => state.gameState);

  // const ownTarafId = kontrolEtmenler
  //   ? units.find((a) => a.id === kontrolEtmenler.find((o) => o.veritabaniId === gameId)?.etmenId)?.taraf?.id
  //   : undefined;
  // const sideRelation = sideRelations.find(
  //   (o) => o.tarafKaynakId === ownTarafId && o.tarafHedefId === selectedUnit?.taraf?.id,
  // )?.deger;
  const isFilteredSensorOrWeapon = (system: SystemStatus) => {
    const foundedSystemData = systems.find((o) => o.id === system.tmkId);
    if (foundedSystemData) {
      if (tmkIsWeapon(foundedSystemData) || tmkIsSensor(foundedSystemData)) {
        return true;
      }
    }
    return false;
  };
  const setFilteredSystem = (system: SystemStatus) => {
    const incomingSystem = systems.find((o) => o.id === system.tmkId);

    if (incomingSystem) {
      setFoundedSystem(incomingSystem);
    }
  };
  const [symbol, setSymbol] = useState<ms.Symbol | undefined | null>(undefined);
  const [foundedSystem, setFoundedSystem] = useState<TmkKalemiOzellikleriResultType>();
  const [isSystemChecked, setIsSystemChecked] = useState<boolean>(false);

  const [selectedUnit, setSelectedUnit] = useState<MapUnit | HlaMapUnit | undefined>(undefined);
  const [showControlMeasures, setShowControlMeasures] = useState<boolean>(false);
  const [viewType, setViewType] = useState<UnitType>();

  const updateWeightUnit = (e: number) => {
    dispatch(unitsActions.changeWeightUnit(e));
    storageHelper.setValueWithKey('weightUnit', String(e));
  };

  useEffect(() => {
    const loadMilSymbol = async () => {
      await preloadMilsymbol();
    };

    loadMilSymbol();
  }, []);

  useEffect(() => {
    const generaUnits = async () => {
      if (selectedUnit) {
        setSymbol(
          await unitSymbolGenerator(selectedUnit, {
            size: 30,
            additionalInfoBool: false,
            isSitrepMode: true,
          }),
        );
      }
    };

    generaUnits();
  }, [selectedUnit]);

  useEffect(() => {
    if (selectedUnitData.unitType === 'hla') {
      setSelectedUnit(hlaMapUnits.find((o) => o.id === selectedUnitData.id) as HlaMapUnit);
      setViewType('hla');
    } else {
      setSelectedUnit(units.find((o) => o.id === selectedUnitData.id) as MapUnit);
      setViewType('hymotsc');
    }
  }, [hlaMapUnits, units]);

  // Handle chagned fields for add them yellow css
  useEffect(() => {
    if (selectedUnit) {
      const sitrepDocument = document.getElementById(`sitrep_${selectedUnit.id}`);

      if (sitrepDocument) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.target.parentElement?.classList.add('highlitedText');
            setTimeout(() => {
              mutation.target.parentElement?.classList.remove('highlitedText');
            }, 500);
          });
        });

        observer.observe(sitrepDocument, {
          subtree: true,
          characterData: true,
        });

        return () => {
          observer.disconnect();
        };
      }
    }
  }, [selectedUnit?.id]);

  // useEffect(() => {
  //   if (selectedUnit && !senseUpdateRestrictions.unsurDurumlari.includes(selectedUnit.algiDurumu)) {
  //     dispatch(
  //       unitsActions.sitrepChangeVisualActive({
  //         id: selectedUnitData.id,
  //         key: 'weaponRangeActive',
  //         bool: false,
  //       }),
  //     );
  //     dispatch(
  //       unitsActions.sitrepChangeVisualActive({
  //         id: selectedUnitData.id,
  //         key: 'sensingRangeActive',
  //         bool: false,
  //       }),
  //     );
  //   }
  // }, [selectedUnit?.algiDurumu]);

  const clearTmkRangeOptions = (label: 'weapon' | 'sensor', bool: boolean) => {
    if (bool) {
      return;
    }
    switch (label) {
      case 'weapon':
        const weapons = filteredSystems.filter((o) => o.unitId === selectedUnit?.id && tmkIsWeapon(o.tmk));

        if (weapons.length > 0) {
          weapons.forEach((o) => {
            if (tmkIsWeapon(o.tmk)) {
              dispatch(contentActions.deleteFilteredSystems({ unitId: o.unitId, tmk: o.tmk }));
            }
          });
          setIsSystemChecked(false);
          setFoundedSystem(undefined);
        }
        break;
      case 'sensor':
        const sensors = filteredSystems.filter((o) => o.unitId === selectedUnit?.id && tmkAlgiYapabilirMi(o.tmk));

        if (sensors.length > 0) {
          sensors.forEach((o) => {
            dispatch(contentActions.deleteFilteredSystems({ unitId: o.unitId, tmk: o.tmk }));
          });
          setIsSystemChecked(false);
          setFoundedSystem(undefined);
        }
        break;
      default:
        break;
    }
  };

  return selectedUnit !== undefined ? (
    <>
      <div className={styles.panelHeaderTemplate}>
        <div
          className="popup-row grid-col-2-fixed sitrep-info"
          onClick={() => {
            dispatch(unitsActions.chSelectUnit(selectedUnit.id));
          }}
        >
          {symbol && <div dangerouslySetInnerHTML={{ __html: symbol.asSVG() }} />}
          <span className={styles.agentShortNameHeader}>{selectedUnit ? getAgentName(selectedUnit) : ''}</span>
        </div>
        <div className="sitrep-checkbox-group">
          <Checkbox
            value="volume"
            checked={selectedUnitData.volumeActive}
            onChange={(e) =>
              dispatch(
                unitsActions.sitrepChangeVisualActive({
                  id: selectedUnitData.id,
                  key: 'volumeActive',
                  bool: e.target.checked,
                }),
              )
            }
          >
            <span title="Volume">{t('hymotsc.sitrep.volume')}</span>
          </Checkbox>

          {viewType === 'hymotsc' && (
            <>
              <Checkbox
                value="weaponRange"
                checked={selectedUnitData.weaponRangeActive}
                onChange={(e) =>
                  dispatch(
                    unitsActions.sitrepChangeVisualActive({
                      id: selectedUnitData.id,
                      key: 'weaponRangeActive',
                      bool: e.target.checked,
                    }),
                  )
                }
              >
                <span title="Weapon Range">{t('hymotsc.sitrep.weaponRange')}</span>
              </Checkbox>
              <Checkbox
                value="sensingRange"
                checked={selectedUnitData.sensingRangeActive}
                onChange={(e) => {
                  dispatch(
                    unitsActions.sitrepChangeVisualActive({
                      id: selectedUnitData.id,
                      key: 'sensingRangeActive',
                      bool: e.target.checked,
                    }),
                  );
                  clearTmkRangeOptions('sensor', e.target.checked);
                }}
              >
                <span title="Sensing Range">{t('hymotsc.sitrep.sensingRange')}</span>
              </Checkbox>
              {/* Not implemented in hymots yet*/}
              {/* <Checkbox
              value="measurements"
              checked={selectedUnitData.measurements}
              onChange={(e) =>
                dispatch(
                  unitsActions.sitrepChangeVisualActive({
                    id: selectedUnitData.id,
                    key: 'measurements',
                    bool: e.target.checked,
                  }),
                )
              }
            >
              <span title="Measurements">Control Measures</span>
            </Checkbox> */}
            </>
          )}
        </div>
      </div>
      <Collapse className="sitrep-collapse">
        <Collapse.Panel header={t('hymotsc.sitrep.details')} key="1">
          <List
            className={styles.contentComponentTemplate}
            bordered
            dataSource={tableContents()}
            renderItem={(item, i) => {
              if (item.key === 'identification') {
                if (selectedUnit.algiDurumu !== 0 && selectedUnit.algiDurumu !== 7) {
                  return (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        {algiBinary[0].options.find((o) => o.value === selectedUnit.algiDurumu)?.label.en}
                      </div>
                    </List.Item>
                  );
                }
                return undefined;
              }

              if (item.key === 'konum') {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${item.title}:`}</span>
                    </div>
                    <div className={styles.listItemContent}>
                      <span id={`sitrep-${selectedUnit.id}-detail-lat`} style={{ display: 'flex' }}>
                        LAT :
                        {!mapVisualSettings?.showDms ? (
                          selectedUnit.konum.lat.toFixed(6)
                        ) : (
                          <div className="sitrepDmsWrapper">
                            <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.lat).degree}</p>
                            <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.lat).minDegree}</p>
                            <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.lat).secDegree}</p>
                          </div>
                        )}
                      </span>
                      <span id={`sitrep-${selectedUnit.id}-detail-lng`} style={{ display: 'flex' }}>
                        LON :
                        {!mapVisualSettings?.showDms ? (
                          selectedUnit.konum.lng.toFixed(6)
                        ) : (
                          <div className="sitrepDmsWrapper">
                            <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.lng).degree}</p>
                            <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.lng).minDegree}</p>
                            <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.lng).secDegree}</p>
                          </div>
                        )}
                      </span>
                      {selectedUnit.konum.alt ? (
                        <span id={`sitrep-${selectedUnit.id}-detail-alt`} style={{ display: 'flex' }}>
                          ALT :
                          {!mapVisualSettings?.showDms ? (
                            selectedUnit.konum.alt.toFixed(6)
                          ) : (
                            <div className="sitrepDmsWrapper">
                              <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.alt).degree}</p>
                              <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.alt).minDegree}</p>
                              <p className="sitrepDms">{latLongToDmsConverter(selectedUnit.konum.alt).secDegree}</p>
                            </div>
                          )}
                        </span>
                      ) : (
                        <span id={`sitrep-${selectedUnit.id}-detail-alt`}>
                          ALT : {!mapVisualSettings?.showDms ? 0 : latLongToDmsConverter(0).degree}
                        </span>
                      )}
                    </div>
                  </List.Item>
                );
              }

              if (item.key === 'istikamet') {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${item.title}:`}</span>
                    </div>
                    <div
                      className={styles.listItemContent}
                      style={{ columnGap: 10, display: 'flex', flexDirection: 'row' }}
                      id={`sitrep-${selectedUnit.id}-detail-${i}`}
                    >
                      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {`${selectedUnit.istikamet.toFixed(2)} °`}
                      </span>

                      <span
                        style={{
                          transform: `rotate(${selectedUnit.istikamet - 90}deg)`,
                          width: 'fit-content',
                          fontSize: '18px',
                        }}
                      >
                        &#8594;
                      </span>
                    </div>
                  </List.Item>
                );
              }

              if (item.key === 'taraf.kisaIsim') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div
                        className={styles.listItemContent}
                        style={{ columnGap: 10, display: 'flex', flexDirection: 'row' }}
                        id={`sitrep-${selectedUnit.id}-detail-${i}`}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                          {selectedUnit.taraf?.kisaIsim}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }
              if (item.key === 'etmenTuru.etmenSinifi.kisaIsim') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div
                        className={styles.listItemContent}
                        style={{ columnGap: 10, display: 'flex', flexDirection: 'row' }}
                        id={`sitrep-${selectedUnit.id}-detail-${i}`}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {selectedUnit.etmenSinifi?.kisaIsim}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }
              if (item.key === 'etmenTuru.kisaIsim') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div
                        className={styles.listItemContent}
                        style={{ columnGap: 10, display: 'flex', flexDirection: 'row' }}
                        id={`sitrep-${selectedUnit.id}-detail-${i}`}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {selectedUnit.etmenTuru?.kisaIsim}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'faaliyeti') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>{`${
                          (selectedUnit.faaliyeti && faaliyetData[selectedUnit.faaliyeti].en) || 'Unknown'
                        }`}</span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'hareketSafhasi') {
                if (
                  !selectedUnit.harekatSafhasi ||
                  selectedUnit.harekatSafhasi === -1 ||
                  ESubFaaliyet[selectedUnit.harekatSafhasi] === undefined
                ) {
                  return undefined;
                }
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {(ESubFaaliyet[selectedUnit.harekatSafhasi] || ESubFaaliyet.IDLE).toString()}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'angajmanKurali') {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${item.title}:`}</span>
                    </div>
                    <div className={styles.listItemContent}>
                      <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                        {selectedUnit.angajmanKurali
                          ? EEngamentRule[selectedUnit.angajmanKurali]?.toString() || '-'
                          : 'Unknown'}
                      </span>
                    </div>
                  </List.Item>
                );
              }

              if (item.key === 'ustIsletenEtmenVtId') {
                const ustIsletenEtmen = units.find((o) => o.id === selectedUnit.ustIsletenEtmenVtId);

                return (
                  viewType == 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {ustIsletenEtmen ? getAgentName(ustIsletenEtmen) : '-'}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'ikmalindenSorumluEtmenVtId') {
                const ikmalindenSorumluEtmen = units.find((o) => o.id === selectedUnit.ikmalindenSorumluEtmenVtId);

                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {ikmalindenSorumluEtmen ? getAgentName(ikmalindenSorumluEtmen) : '-'}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'hacim') {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${item.title}:`}</span>
                    </div>
                    <div className={styles.listItemContent} id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                      <Tooltip placement="topLeft" zIndex={tooltipZIndex} title="Length">
                        <span>{`L : ${selectedUnit.hacim.uzunluk.toFixed(2)} m`}</span>
                      </Tooltip>
                      <Tooltip placement="topLeft" zIndex={tooltipZIndex} title="Width">
                        <span>{`W : ${selectedUnit.hacim.genislik.toFixed(2)} m`}</span>
                      </Tooltip>
                      <Tooltip placement="topLeft" zIndex={tooltipZIndex} title="Heigth">
                        <span>{`H : ${selectedUnit.hacim.yukseklik.toFixed(2)} m`}</span>
                      </Tooltip>
                    </div>
                  </List.Item>
                );
              }

              if (item.key === 'hiz') {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${item.title}:`}</span>
                    </div>
                    <div className={styles.listItemContent}>
                      <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                        {prototypeIsNaval(selectedUnit.etmenTuru?.sembolu) &&
                        !isAirMissileIcon(selectedUnit.etmenTuru?.sidc)
                          ? `${convertMeasurement('kphToKn', selectedUnit?.hiz).toFixed(2)} knot(s)`
                          : `${selectedUnit?.hiz?.toFixed(2)} km/h`}
                      </span>
                    </div>
                  </List.Item>
                );
              }

              if (item.key === 'forceIdentifier') {
                return (
                  (selectedUnit as HlaMapUnit).forceIdentifier !== undefined && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {HLAForceIdentifierEnum[(selectedUnit as HlaMapUnit).forceIdentifier || 0]}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'echelon') {
                return (
                  (selectedUnit as HlaMapUnit).echelon && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {HLAEchelonEnum[(selectedUnit as HlaMapUnit).echelon]}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'owner') {
                return (
                  (selectedUnit as HlaMapUnit).owner && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {(selectedUnit as HlaMapUnit).owner.replaceAll(' ', '').toLocaleLowerCase() === 'hymotsc'
                            ? 'Hymots®c'
                            : (selectedUnit as HlaMapUnit).owner.toLocaleUpperCase()}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'bindirilmisMi') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>{`${
                          isDefined(selectedUnit.bindirilmisMi)
                            ? selectedUnit.bindirilmisMi
                              ? 'YES'
                              : 'NO'
                            : 'Unknown'
                        }`}</span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'savunma.hazirlikSuresi') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>{`${(
                          (selectedUnit.savunma?.hazirlikSuresi || 0) / 3600
                        ).toFixed(2)} h`}</span>
                      </div>
                    </List.Item>
                  )
                );

                return undefined;
              }

              if (item.key === 'savunma.savunmaYuzdesi') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {`${Number(selectedUnit.savunma?.savunmaYuzdesi).toFixed(2)} %`}{' '}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'insanZayiatOrani') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {selectedUnit.insanZayiatOrani !== undefined
                            ? `${Number(selectedUnit.insanZayiatOrani).toFixed(2)} %`
                            : 'Unknown'}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'otonomZayiatOrani') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {selectedUnit.otonomZayiatOrani !== undefined
                            ? `${Number(selectedUnit.otonomZayiatOrani).toFixed(2)} %`
                            : 'Unknown'}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }

              if (item.key === 'magicIkmal') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {selectedUnit.magicIkmal ? 'YES' : 'NO'}{' '}
                        </span>
                      </div>
                    </List.Item>
                  )
                );

                return undefined;
              }

              if (item.key === 'beklemeSuresi') {
                if (
                  (selectedUnit.harekatSafhasi &&
                    selectedUnit.harekatSafhasi !== 1 &&
                    selectedUnit.harekatSafhasi === ESubFaaliyet['AIR WAITING FUEL SUPPLY']) ||
                  selectedUnit.harekatSafhasi === ESubFaaliyet['AIR FLIGHT PREPARATION'] ||
                  selectedUnit.harekatSafhasi === ESubFaaliyet['AIR WAITING']
                ) {
                  return (
                    viewType === 'hymotsc' && (
                      <List.Item className={styles.listItemTemplate}>
                        <div className={styles.listItemTitle}>
                          <span>{`${item.title}:`}</span>
                        </div>
                        <div className={styles.listItemContent}>
                          <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                            {selectedUnit.beklemeSuresi
                              ? `${remainingTimeCalculator(selectedUnit.beklemeSuresi).days}d ${
                                  remainingTimeCalculator(selectedUnit.beklemeSuresi).hours
                                }h ${remainingTimeCalculator(selectedUnit.beklemeSuresi).mins}m ${
                                  remainingTimeCalculator(selectedUnit.beklemeSuresi).secs
                                }s`
                              : '-'}
                          </span>
                        </div>
                      </List.Item>
                    )
                  );
                }
                return undefined;
              }

              if (item.key === 'aisDurumu') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>
                          {selectedUnit.aisDurumu ? 'YES' : 'NO'}{' '}
                        </span>
                      </div>
                    </List.Item>
                  )
                );

                return undefined;
              }

              if (item.key === 'uzunIsim') {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${item.title}:`}</span>
                    </div>
                    <div
                      className={styles.listItemContent}
                      style={{ fontSize: selectedUnit.uzunIsim.length > 20 ? 10 : 12 }}
                    >
                      <span id={`sitrep-${selectedUnit.id}-detail-${i}`}>{getAnyField(selectedUnit, 'uzunIsim')}</span>
                    </div>
                  </List.Item>
                );
              }

              const splittedKey = item.key.split('.')[0] as keyof typeof senseUpdateRestrictions;
              return (
                viewType === 'hymotsc' && (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${item.title}:`}</span>
                    </div>
                    <div className={styles.listItemContent}>{get(selectedUnit, item.key)}</div>
                  </List.Item>
                )
              );
              return (
                <List.Item className={styles.listItemTemplate}>
                  <div className={styles.listItemTitle}>
                    <span>{`${item.title}:`}</span>
                  </div>
                  <div className={styles.listItemContent}>Unknown</div>
                </List.Item>
              );
            }}
          />
        </Collapse.Panel>
        {viewType === 'hymotsc' && (
          <Collapse.Panel header={t('hymotsc.sitrep.manifest')} key="2">
            {selectedUnit.manifesto && selectedUnit.manifesto.length === 0 ? (
              <div style={{ textAlign: 'center' }}>{t('hymotsc.sitrep.noData')}</div>
            ) : (
              <List
                className={styles.contentComponentTemplate}
                bordered
                header={
                  <div className="popup-row grid-col-3-fixed status-list-header">
                    <span>{t('hymotsc.sitrep.noData')}</span>
                    <span>{t('hymotsc.tableColumns.secrecy')}</span>
                    <span>{t('hymotsc.tableColumns.liftingType')}</span>
                  </div>
                }
                dataSource={selectedUnit.manifesto}
                renderItem={(item) => {
                  return (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemContent}>
                        <span>{`${units.find((o) => o.id === item.tasinanEtmenId)?.kisaIsim || ''}`}</span>
                      </div>

                      <div className={styles.listItemContent}>
                        <span>{`${item.gizlilikDerecesi} %`}</span>
                      </div>

                      <div className={styles.listItemContent}>
                        <span>{`${(TasimaTipi[item.tasimaTipi] as keyof typeof TasimaTipi) || ''}`}</span>
                      </div>
                    </List.Item>
                  );
                }}
              />
            )}
          </Collapse.Panel>
        )}

        {selectedUnit.supplyStatus && selectedUnit.supplyStatus.length > 0 && (
          <Collapse.Panel header={t('hymotsc.sitrep.supplyStatus')} key="3" className="supplies-collapse">
            <div className="sitrep-units-display">
              <Select
                className={styles.select}
                value={weightUnit}
                onChange={(e: number) => updateWeightUnit(e)}
                style={{ width: '5vw' }}
                size="small"
              >
                <Select.Option key={EWeightUnit.Metric} value={EWeightUnit.Metric}>
                  {t('hymotsc.sitrep.metric')}
                </Select.Option>
                <Select.Option key={EWeightUnit.US} value={EWeightUnit.US}>
                  {t('hymotsc.sitrep.us')}
                </Select.Option>
              </Select>
            </div>
            <List
              className={styles.contentComponentTemplate}
              bordered
              header={
                <div className="popup-row grid-col-3-fixed status-list-header">
                  <span>{t('hymotsc.tableColumns.name')}</span>
                  <span>{t('hymotsc.tableColumns.current')}</span>
                  <span>{t('hymotsc.tableColumns.target')}</span>
                </div>
              }
              dataSource={selectedUnit.supplyStatus}
              renderItem={(item, i) => {
                const supply = supplies.find((o) => o.id === item.ikmalId);

                const kgBased = ['Ton', 'Kilogram'];

                let currentAmountText = '';
                let targetAmountText = '';
                if (!item.currentAmount?.toLocaleString()) {
                  currentAmountText = '-';
                } else if (kgBased.includes(getEnumKeyByValue2(EIkmalBirim, supply?.birim))) {
                  if (weightUnit === EWeightUnit.Metric) {
                    currentAmountText = getProperWeightText(weightUnit, item.currentAmount);
                  } else if (weightUnit === EWeightUnit.US) {
                    currentAmountText = getProperWeightText(
                      weightUnit,
                      convertMeasurement('kgToLbs', item.currentAmount),
                    );
                  }
                } else {
                  currentAmountText = item.currentAmount?.toLocaleString();
                }

                if (!item.targetAmount?.toLocaleString()) {
                  targetAmountText = '-';
                } else if (kgBased.includes(getEnumKeyByValue2(EIkmalBirim, supply?.birim))) {
                  if (weightUnit === EWeightUnit.Metric) {
                    targetAmountText = getProperWeightText(weightUnit, item.targetAmount);
                  } else if (weightUnit === EWeightUnit.US) {
                    targetAmountText = getProperWeightText(
                      weightUnit,
                      convertMeasurement('kgToLbs', item.targetAmount),
                    );
                  }
                } else {
                  targetAmountText = item.targetAmount?.toLocaleString();
                }

                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${supply?.kisaIsim || ''}`}</span>
                    </div>
                    <div
                      id={`sitrep-${selectedUnit.id}-supply-${i}`}
                      className="popup-row grid-col-2-fixed status-list-content"
                    >
                      <span>{currentAmountText}</span>
                      <span>{targetAmountText}</span>
                    </div>
                  </List.Item>
                );
              }}
            />
          </Collapse.Panel>
        )}

        {selectedUnit.systemStatus && selectedUnit.systemStatus.length > 0 && (
          <Collapse.Panel header={t('hymotsc.sitrep.systemStatus')} key="4">
            <List
              className={styles.contentComponentTemplate}
              bordered
              header={
                <>
                  <div className="popup-row grid-col-3-fixed status-list-header">
                    <span>{t('hymotsc.tableColumns.name')}</span>
                    <span>{t('hymotsc.tableColumns.current')}</span>
                    <Tooltip
                      placement="topLeft"
                      zIndex={tooltipZIndex}
                      title={t('hymotsc.tableColumns.wounded/Casualty/Mixed/CBRN')}
                    >
                      <span>WO/CA/MX/CB</span>
                    </Tooltip>
                  </div>
                </>
              }
              dataSource={selectedUnit.systemStatus}
              renderItem={(item, i) => {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${systems.find((o) => o.id === item.tmkId)?.kisaIsim || ''}:`}</span>
                    </div>
                    <div
                      id={`sitrep-${selectedUnit.id}-system-${i}`}
                      className="popup-row grid-col-2-fixed status-list-content"
                    >
                      <span>{item.currentAmount.toLocaleString()}</span>
                      <span className={styles.info}>
                        {item.wounded.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.wounded.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.wounded.toLocaleString()}</span>
                        )}
                        /
                        {item.casualty.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.casualty.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.casualty.toLocaleString()}</span>
                        )}
                        /
                        {item.karistirilmis.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.karistirilmis.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.karistirilmis.toLocaleString()}</span>
                        )}
                        /
                        {item.kbrnEtkisinde.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.kbrnEtkisinde.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.kbrnEtkisinde.toLocaleString()}</span>
                        )}
                        {/* <span>
                          {isFilteredSensorOrWeapon(item) &&
                            (selectedUnitData.sensingRangeActive || selectedUnitData.weaponRangeActive) && (
                              <Checkbox
                                // checked={isSystemChecked}
                                className={styles.tmkCheckbox}
                                onChange={(e) => {
                                  setFilteredSystem(item);
                                  setIsSystemChecked(e.target.checked);
                                }}
                              />
                            )}
                        </span> */}
                      </span>
                    </div>
                  </List.Item>
                );
              }}
            />
          </Collapse.Panel>
        )}

        {selectedUnit.aircraftsStatus && selectedUnit.aircraftsStatus.length > 0 && (
          <Collapse.Panel header={t('hymotsc.sitrep.aircraftsStatus')} key="5">
            <List
              className={styles.contentComponentTemplate}
              bordered
              header={
                <>
                  <div className="popup-row grid-col-3-fixed status-list-header">
                    <span>{t('hymotsc.tableColumns.name')}</span>
                    <span>{t('hymotsc.tableColumns.current')}</span>
                    <Tooltip
                      placement="topLeft"
                      zIndex={tooltipZIndex}
                      title={t('hymotsc.tableColumns.wounded/Casualty/Mixed/CBRN')}
                    >
                      <span>WO/CA/MX/CB</span>
                    </Tooltip>
                  </div>
                </>
              }
              dataSource={selectedUnit.aircraftsStatus}
              renderItem={(item, i) => {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${aircrafts.find((o) => o.id === item.havaAraciId)?.kisaIsim || ''}:`}</span>
                    </div>
                    <div
                      id={`sitrep-${selectedUnit.id}-aircraft-${i}`}
                      className="popup-row grid-col-2-fixed status-list-content"
                    >
                      <span>{item.currentAmount.toLocaleString()}</span>
                      <span className={styles.info}>
                        {item.wounded.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.wounded.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.wounded.toLocaleString()}</span>
                        )}
                        /
                        {item.casualty.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.casualty.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.casualty.toLocaleString()}</span>
                        )}
                        /
                        {item.karistirilmis.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.karistirilmis.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.karistirilmis.toLocaleString()}</span>
                        )}
                        /
                        {item.kbrnEtkisinde.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.kbrnEtkisinde.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.kbrnEtkisinde.toLocaleString()}</span>
                        )}
                        <span />
                      </span>
                    </div>
                  </List.Item>
                );
              }}
            />
          </Collapse.Panel>
        )}

        {selectedUnit.navalcraftsStatus && selectedUnit.navalcraftsStatus.length > 0 && (
          <Collapse.Panel header={t('hymotsc.sitrep.navalcraftsStatus')} key="6">
            <List
              className={styles.contentComponentTemplate}
              bordered
              header={
                <>
                  <div className="popup-row grid-col-3-fixed status-list-header">
                    <span>{t('hymotsc.tableColumns.name')}</span>
                    <span>{t('hymotsc.tableColumns.current')}</span>
                    <Tooltip
                      placement="topLeft"
                      zIndex={tooltipZIndex}
                      title={t('hymotsc.tableColumns.wounded/Casualty/Mixed/CBRN')}
                    >
                      <span>WO/CA/MX/CB</span>
                    </Tooltip>
                  </div>
                </>
              }
              dataSource={selectedUnit.navalcraftsStatus}
              renderItem={(item, i) => {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${navalcrafts.find((o) => o.id === item.denizAraciId)?.kisaIsim || ''}:`}</span>
                    </div>
                    <div
                      id={`sitrep-${selectedUnit.id}-navalcraft-${i}`}
                      className="popup-row grid-col-2-fixed status-list-content"
                    >
                      <span>{item.currentAmount.toLocaleString()}</span>
                      <span className={styles.info}>
                        {item.wounded.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.wounded.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.wounded.toLocaleString()}</span>
                        )}
                        /
                        {item.casualty.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.casualty.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.casualty.toLocaleString()}</span>
                        )}
                        /
                        {item.karistirilmis.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.karistirilmis.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.karistirilmis.toLocaleString()}</span>
                        )}
                        /
                        {item.kbrnEtkisinde.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.kbrnEtkisinde.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.kbrnEtkisinde.toLocaleString()}</span>
                        )}
                        <span />
                      </span>
                    </div>
                  </List.Item>
                );
              }}
            />
          </Collapse.Panel>
        )}

        {selectedUnit.obstaclesStatus && selectedUnit.obstaclesStatus.length > 0 && (
          <Collapse.Panel header={t('hymotsc.sitrep.obstacleStatus')} key="7">
            <List
              className={styles.contentComponentTemplate}
              bordered
              header={
                <>
                  <div className="popup-row grid-col-3-fixed status-list-header">
                    <span>{t('hymotsc.tableColumns.name')}</span>
                    <span>{t('hymotsc.tableColumns.current')}</span>
                    <Tooltip
                      placement="topLeft"
                      zIndex={tooltipZIndex}
                      title={t('hymotsc.tableColumns.wounded/Casualty/Mixed/CBRN')}
                    >
                      <span>WO/CA/MX/CB</span>
                    </Tooltip>
                    <Tooltip
                      placement="topLeft"
                      zIndex={tooltipZIndex}
                      title="Anti Personel/Vehicle/Armor/Embarkment-Disembarkment Qty"
                    >
                      <span>P/V/A/ED</span>
                    </Tooltip>
                  </div>
                </>
              }
              dataSource={selectedUnit.obstaclesStatus}
              renderItem={(item, i) => {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${obstacles.find((o) => o.id === item.engelId)?.kisaIsim || ''}:`}</span>
                    </div>
                    <div
                      id={`sitrep-${selectedUnit.id}-obstacle-${i}`}
                      className="popup-row grid-col-3-fixed status-list-content status-list-content-three-columns"
                      style={{ flex: '100%' }}
                    >
                      <span>{item.currentAmount.toLocaleString()}</span>
                      <span className={styles.info}>
                        {item.wounded.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.wounded.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.wounded.toLocaleString()}</span>
                        )}
                        /
                        {item.casualty.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.casualty.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.casualty.toLocaleString()}</span>
                        )}
                        /
                        {item.karistirilmis.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.karistirilmis.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.karistirilmis.toLocaleString()}</span>
                        )}
                        /
                        {item.kbrnEtkisinde.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.kbrnEtkisinde.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.kbrnEtkisinde.toLocaleString()}</span>
                        )}
                      </span>
                      {item.engelMevcutlari && (
                        <span className={styles.info}>
                          {item.engelMevcutlari.antiPersonelMiktari.toLocaleString().length > 2 ? (
                            <Tooltip
                              placement="topLeft"
                              zIndex={tooltipZIndex}
                              title={item.engelMevcutlari.antiPersonelMiktari.toLocaleString()}
                            >
                              99<sup>+</sup>
                            </Tooltip>
                          ) : (
                            <span>{item.engelMevcutlari.antiPersonelMiktari.toLocaleString()}</span>
                          )}
                          /
                          {item.engelMevcutlari.antiAracMiktari.toLocaleString().length > 2 ? (
                            <Tooltip
                              placement="topLeft"
                              zIndex={tooltipZIndex}
                              title={item.engelMevcutlari.antiAracMiktari.toLocaleString()}
                            >
                              99<sup>+</sup>
                            </Tooltip>
                          ) : (
                            <span>{item.engelMevcutlari.antiAracMiktari.toLocaleString()}</span>
                          )}
                          /
                          {item.engelMevcutlari.antiZirhliMiktari.toLocaleString().length > 2 ? (
                            <Tooltip
                              placement="topLeft"
                              zIndex={tooltipZIndex}
                              title={item.engelMevcutlari.antiZirhliMiktari.toLocaleString()}
                            >
                              99<sup>+</sup>
                            </Tooltip>
                          ) : (
                            <span>{item.engelMevcutlari.antiZirhliMiktari.toLocaleString()}</span>
                          )}
                          /
                          {item.engelMevcutlari.AntiIndirmeCikartmaMiktari.toLocaleString().length > 2 ? (
                            <Tooltip
                              placement="topLeft"
                              zIndex={tooltipZIndex}
                              title={item.engelMevcutlari.AntiIndirmeCikartmaMiktari.toLocaleString()}
                            >
                              99<sup>+</sup>
                            </Tooltip>
                          ) : (
                            <span>{item.engelMevcutlari.AntiIndirmeCikartmaMiktari.toLocaleString()}</span>
                          )}
                        </span>
                      )}
                    </div>
                  </List.Item>
                );
              }}
            />
          </Collapse.Panel>
        )}

        {selectedUnit.commDevicesStatus && selectedUnit.commDevicesStatus.length > 0 && (
          <Collapse.Panel header={t('hymotsc.sitrep.communicationsDeviceStatus')} key="8">
            <List
              className={styles.contentComponentTemplate}
              bordered
              header={
                <>
                  <div className="popup-row grid-col-3-fixed status-list-header">
                    <span>{t('hymotsc.tableColumns.name')}</span>
                    <span>{t('hymotsc.tableColumns.current')}</span>
                    <Tooltip
                      placement="topLeft"
                      zIndex={tooltipZIndex}
                      title={t('hymotsc.tableColumns.wounded/Casualty/Mixed/CBRN')}
                    >
                      <span>WO/CA/MX/CB</span>
                    </Tooltip>
                  </div>
                </>
              }
              dataSource={selectedUnit.commDevicesStatus}
              renderItem={(item, i) => {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${commdevices.find((o) => o.id === item.muhabereCihaziId)?.kisaIsim || ''}:`}</span>
                    </div>
                    <div
                      id={`sitrep-${selectedUnit.id}-comm-device-${i}`}
                      className="popup-row grid-col-2-fixed status-list-content"
                    >
                      <span>{item.currentAmount.toLocaleString()}</span>
                      <span className={styles.info}>
                        {item.wounded.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.wounded.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.wounded.toLocaleString()}</span>
                        )}
                        /
                        {item.casualty.toLocaleString().length > 2 ? (
                          <Tooltip placement="topLeft" zIndex={tooltipZIndex} title={item.casualty.toLocaleString()}>
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.casualty.toLocaleString()}</span>
                        )}
                        /
                        {item.karistirilmis.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.karistirilmis.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.karistirilmis.toLocaleString()}</span>
                        )}
                        /
                        {item.kbrnEtkisinde.toLocaleString().length > 2 ? (
                          <Tooltip
                            placement="topLeft"
                            zIndex={tooltipZIndex}
                            title={item.kbrnEtkisinde.toLocaleString()}
                          >
                            99<sup>+</sup>
                          </Tooltip>
                        ) : (
                          <span>{item.kbrnEtkisinde.toLocaleString()}</span>
                        )}
                        <span />
                      </span>
                    </div>
                  </List.Item>
                );
              }}
            />
          </Collapse.Panel>
        )}

        <Collapse.Panel header={t('hymotsc.sitrep.activity')} key="9">
          <List
            className={styles.contentComponentTemplate}
            bordered
            dataSource={activityContents()}
            renderItem={(item, i) => {
              const disciplineParameter =
                viewType === 'hymotsc'
                  ? `${Number(((selectedUnit.etkinlik?.disiplinVeMoralParametresi || 0) * 100) / 255).toFixed(2)} %`
                  : `${Number(selectedUnit.etkinlik?.disiplinVeMoralParametresi || 0)} %`;

              if (item.key === 'disiplinVeMoralParametresi') {
                return (
                  <List.Item className={styles.listItemTemplate}>
                    <div className={styles.listItemTitle}>
                      <span>{`${item.title}:`}</span>
                    </div>
                    <div className={styles.listItemContent}>
                      <span id={`sitrep-${selectedUnit.id}-activity-${i}`}>{disciplineParameter}</span>
                    </div>
                  </List.Item>
                );
              }

              if (item.key === 'egitimSeviyesiParametresi') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-activity-${i}`}>
                          {`${Number(((selectedUnit.etkinlik?.egitimSeviyesiParametresi || 0) * 100) / 255).toFixed(
                            2,
                          )} %`}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }
              if (item.key === 'meskunMahalParametresi') {
                return (
                  viewType === 'hymotsc' && (
                    <List.Item className={styles.listItemTemplate}>
                      <div className={styles.listItemTitle}>
                        <span>{`${item.title}:`}</span>
                      </div>
                      <div className={styles.listItemContent}>
                        <span id={`sitrep-${selectedUnit.id}-activity-${i}`}>
                          {`${Number(((selectedUnit.etkinlik?.meskunMahalParametresi || 0) * 100) / 255).toFixed(2)} %`}
                        </span>
                      </div>
                    </List.Item>
                  )
                );
              }
              return (
                <List.Item className={styles.listItemTemplate}>
                  <div className={styles.listItemTitle}>
                    <span>{`${item.title}:`}</span>
                  </div>
                  <div id={`sitrep-${selectedUnit.id}-activity-${i}`} className={styles.listItemContent}>
                    {get(selectedUnit.etkinlik, item.key)}
                  </div>
                </List.Item>
              );
            }}
          />
        </Collapse.Panel>
      </Collapse>
    </>
  ) : (
    <></>
  );
};

export default SitrepBar;
